export class Formrequest {
  public uuid: string;
  public data: string;
  public subject: string;
  public name: string;
  public message: string;
  public email: string;
  public url: string;
  public privacy: boolean = false;

  constructor() {}
}

export class FormrequestCareer {
  public uuid: string;
  public data: string;
  public subject: string;
  public name: string;
  public message: string;
  public email: string;
  public url: string;
  public privacy: boolean = false;
  public immagine: string;
  public posizione: string;

  constructor() {}
}
